import "./HrJob.scss";
import CircularButton, { CustomButton, CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import newRequest from "../../../utils/newRequest.js";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Popover
} from "@mui/material";
import { showToast } from "../../../toastService.js";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { SlArrowDown } from "react-icons/sl";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { FiSearch } from "react-icons/fi";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";
import { MdAdd, MdArrowBackIos, MdClose, MdDelete, MdEdit } from "react-icons/md";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { IoDocumentTextSharp } from "react-icons/io5";
import { fetchSystemCodes } from "../../../utils/genericFunctions.js";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { useRef } from "react";


const HrJob = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isJobDialogOpen, setIsJobDialogOpen] = useState(false);
  const [jobAction, setJobAction] = useState(null);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const location = useLocation();
  const showBack = location.state?.showBack || "N";
  const favMenu = location.state?.favMenu || "N";
  const menuDocid = location.state?.menuDocid || undefined;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [detailsPerPage, setDetailsPerPage] = useState(5);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [jobPage, setJobPage] = useState(0);
  const [jobs, setJobs] = useState([]);
  const [sysType, setSysType] = useState(null);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
    param1: "",
    param2: "",
  });
  const newCodeRef = useRef(null);
  const [jobCode, setJobCode] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [jobSummary, setJobSummary] = useState("");
  const [jobExperience, setJobExperience] = useState("");
  const [jobStatus, setJobStatus] = useState({
    value: "New",
    label: "New"
  });
  const [applicableJobStatuses, setApplicableJobStatuses] = useState("");

  const [searchTermJob, setSearchTermJob] = useState("");
  const [responsibilitiesPage, setResponsibilitiesPage] = useState(0);
  const [qualificationsPage, setQualificationsPage] = useState(0);
  const [rowsPerPageResponsibilities, setRowsPerPageResponsibilities] = useState(5);
  const [rowsPerPageQualifications, setRowsPerPageQualifications] = useState(5);

  const [jobResponsibilities, setJobResponsibilities] = useState([]);
  const [jobQualifications, setJobQualifications] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [selectedResponsibility, setSelectedResponsibility] = useState(null);
  const [selectedQualification, setSelectedQualification] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);

  const [selectedSysCode, setSelectedSysCode] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? 'simple-popover' : undefined;


  const fetchJobs = async () => {
    try {
      const res = await newRequest.post("/hrJob/findAll", { job_status: "", result_limit: 100 });
      if (res.data) {
        const sortedJobs = res.data?.sort((a, b) =>
          new Date(b.updatedAt) - new Date(a.updatedAt)
        );
        setJobs(sortedJobs);
      } else {
        setJobs([]);
      }
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  const definedStatuses = async () => {
    try {
      const options = ["New", "Active", "Under Review", "Closed"]?.map((val) => ({
        value: val,
        label: val,
      }));
      setApplicableJobStatuses(options);
    } catch (error) {
      console.error("Error fetching defined sectors :", error);
    }
  };

  const handleJobChangePage = (event, newPage) => {
    setJobPage(newPage);
  };

  const handleJobChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setJobPage(0);
  };

  const filteredJobsData = jobs?.filter(
    (item) =>
      item.job_title?.toLowerCase().includes(searchTermJob?.toLowerCase())
  );

  const slicedJobsData = filteredJobsData?.slice(
    jobPage * rowsPerPage,
    jobPage * rowsPerPage + rowsPerPage
  );


  const handleAccodionChange = (panel, job) => (event, isExpanded) => {
    try {
      setExpanded(isExpanded ? panel : false);
      setSelectedJob(job);
      setJobResponsibilities(job?.job_responsibilities);
      setJobQualifications(job?.job_qualifications);
    } catch (error) {
      console.log(error)
    }
  };


  const handleResponsibilitiesChangePage = (event, newPage) => {
    setResponsibilitiesPage(newPage);
  };

  const handleResponsibilitiesChangeRowsPerPage = (event) => {
    setRowsPerPageResponsibilities(parseInt(event.target.value, 5));
    setResponsibilitiesPage(0);
  };

  const filteredResponsibilitiesData = jobResponsibilities;
  const slicedResponsibilitiesData = filteredResponsibilitiesData.slice(
    responsibilitiesPage * detailsPerPage,
    responsibilitiesPage * detailsPerPage + detailsPerPage
  );

  const filteredQualificationsData = jobQualifications;
  const slicedQualificationsData = filteredQualificationsData.slice(
    qualificationsPage * detailsPerPage,
    qualificationsPage * detailsPerPage + detailsPerPage
  );

  const handleQualificationsChangeRowsPerPage = (event) => {
    setRowsPerPageQualifications(parseInt(event.target.value, 5));
    setQualificationsPage(0);
  };

  const handleQualificationsChangePage = (event, newPage) => {
    setQualificationsPage(newPage);
  };




  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteResponsibility") {
        await newRequest.post("/glJob/delResponsibility", {
          job_docid: selectedJob._id,
          branch_code: objectToAction.object_id
        });
        fetchJobs();
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleJobAction = async () => {
    try {
      if (!jobCode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter code!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!jobTitle) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter title!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (jobAction === "addJob") {
        const res = await newRequest.post(
          "/hrJob/add",
          {
            job_code: jobCode,
            job_title: jobTitle,
            job_summary: jobSummary || jobTitle || "",
            job_experience: jobExperience || "",
            job_responsibilities: [],
            job_qualifications: [],
          }
        );
        if (res.data?.msg === "added") {
          setJobs((prevData) => {
            const updated = [...prevData, res.data?.doc];
            return updated.sort(
              (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
            );
          });
          setIsJobDialogOpen(false);
          showToast(`${jobTitle} added!`, "success");
          resetAction();
        } else if (res.data?.msg === "exists") {
          showToast(t('jobCodeExists', { param1: jobCode }), "error");
        } else {
          showToast(res.data?.msg, "error");
        }
      } else if (jobAction === "editJob") {
        const res = await newRequest.put(
          `/hrJob/upd/${selectedJob._id}`,
          {
            job_title: jobTitle,
            job_summary: jobSummary || jobTitle || "",
            job_experience: jobExperience || "",
            job_status: jobStatus?.value || "New",
          }
        );
        if (res.data?.msg === "updated") {
          const updatedJob = res.data?.doc;
          setJobs((prevJobs) => { return prevJobs.map((job) => job?._id === updatedJob?._id ? updatedJob : job); });
          setIsJobDialogOpen(false);
          showToast(`${jobTitle} updated!`, "success");
          resetAction();
        } else {
          showToast("Error updating job!", "error");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const resetAction = () => {
    setJobAction(null);
    setJobCode("");
    setJobTitle("");
    setJobSummary("");
    setJobExperience("");
    setJobStatus(null);
  };


  useEffect(() => {
    fetchJobs();
    definedStatuses();
  }, []);



  return (
    <motion.div
      className="job"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="job-navbar">
        <div className="job-navbar-left">
          <div className="search-input-wrapper" style={{ width: "90%" }}>
            <FiSearch className="search-input-icon" />
            <input
              className="search-input"
              type="text"
              placeholder={`${t('search')} ${t('job')}`}
              value={searchTermJob}
              onChange={(e) => setSearchTermJob(e.target.value)}
            />
            {searchTermJob?.length > 0 && (
              <MdClose
                onClick={() => setSearchTermJob("")}
                className="search-input-icon"
              />
            )}
          </div>
        </div>
        <div className="job-navbar-right">
          <CustomLoadingButton
            currentTheme={currentTheme}
            borderRadiusType="both"
            variant="tint"
            color="#0ea5a4"
            tooltip={"Add new job"}
            iconPosition="end"
            endIcon={<MdAdd />}
            onClick={() => {
              try {
                resetAction();
                setJobAction("addJob");
                setIsJobDialogOpen(true);
              } catch (error) {
                console.log(error);
              }
            }}
          >
            {t('add')}
          </CustomLoadingButton>
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="both"
            variant="tint"
            color="#2563EB"
            tooltip="Run reports for this document"
            endIcon={<IoDocumentTextSharp />}
            onClick={() => setReportsDialogOpen(true)}>
            {t('reports')}
          </CustomLoadingButton>
          {/* This part shows if the menu was opened from home screen */}
          {showBack === "Y" && <hr className="separator-v" />}
          {showBack === "Y" &&
            <span className="back-icon" onClick={() => navigate(-1)}>
              <MdArrowBackIos size={24} />
            </span>}
        </div>
      </div>
      {slicedJobsData?.length > 0 &&
        <div className="job-table-content">
          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
            className="table-container">
            <Table sx={{ width: "max-content", border: 'none' }}>
              <TableBody className="tablebody-accordion">
                {slicedJobsData?.map((job, index) => (
                  <TableRow
                    key={job?._id}
                    className="tablerow-accordion">
                    <TableCell className="table-cell-accordion"
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                      <Accordion className="accordion" expanded={expanded === job?._id} onChange={handleAccodionChange(job?._id, job)}>
                        <AccordionSummary
                          className="accordion-summary"
                          expandIcon={<SlArrowDown className="content-accordion-expand-icon" style={{ color: "#f44336", fontWeight: "bold" }} />}
                          id={`panel-${job?._id}-header`}
                        >
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", marginRight: "50px" }}>
                            <Typography>
                              <h1 className="main-title">{jobPage * rowsPerPage + index + 1}. {job?.job_title}</h1>
                            </Typography>
                            <Typography>
                              <div className="job-details-wrapper">
                                <div className={`job-details status ${job?.job_status}`}>
                                  <h1 className="account-no">{`CODE: ${job?.job_code}`}</h1>
                                  <h1 className="account-no">{`STATUS: ${job?.job_status}`}</h1>
                                </div>
                                <CircularButton
                                  currentTheme={currentTheme}
                                  onClick={async (e) => {
                                    try {
                                      setJobCode(job?.job_code);
                                      setJobTitle(job?.job_title);
                                      setJobSummary(job?.job_summary);
                                      setJobExperience(job?.job_experience);
                                      setJobStatus({
                                        value: job?.job_status,
                                        label: job?.job_status
                                      });
                                      setJobAction("editJob");
                                      setIsJobDialogOpen(true);
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdEdit color="purple" />} width={"30px"} height={"30px"} />
                              </div>
                            </Typography>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details">
                          <div className="accordion-table">
                            <div className="accordion-left">
                              <div style={{ display: "flex", flexDirection: "row", gap: "3px", alignItems: "center", paddingLeft: "5px" }}>
                                <span className="sub-title">{t('responsibilities')}</span>
                                <CircularButton
                                  currentTheme={currentTheme}
                                  aria-describedby={id}
                                  onClick={(e) => {
                                    try {
                                      setSysType("Job Responsibilities");
                                      setSelectedSysCode(null);
                                      setAnchorEl(e.currentTarget);
                                      if (newCodeRef.current) {
                                        newCodeRef.current.focus();
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdAdd color="green" />} width={"30px"} height={"30px"} />
                              </div>
                              <div className="table-content">
                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                  <Table sx={{ width: "max-content", border: 'none' }}>
                                    <TableBody className="tablebody">
                                      {slicedResponsibilitiesData?.map((row, index) => (
                                        <TableRow
                                          key={row?.resp_code_xx}
                                          className={`${selectedResponsibility?.resp_code_xx === row?.resp_code_xx ? "tablerow current" : "tablerow"}`}
                                          onClick={() => setSelectedResponsibility(row)}
                                        >
                                          <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                                            {responsibilitiesPage * rowsPerPage + index + 1}
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                                            <span className="sub-title">{row?.resp_code_xx}</span>
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            <span className="sub-title">{row?.resp_text_xx}</span>
                                          </TableCell>
                                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            <CircularButton
                                              currentTheme={currentTheme}
                                              onClick={async (e) => {
                                                try {
                                                  const res = await newRequest.post(`/hrJob/delResp/${selectedJob._id}`, { selected_code: row?.resp_code_xx });
                                                  if (res.data?.msg === "removed") {
                                                    setJobResponsibilities((prevData) => prevData.filter(doc => doc !== row));
                                                    showToast("Removed!", "success");
                                                  } else {
                                                    showToast("Error removing responsibility!", "error");
                                                  }
                                                } catch (error) {
                                                  console.log(error);
                                                }
                                              }}
                                              color="#E53935" icon={<MdDelete />} width={"30px"} height={"30px"} />
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                  {jobResponsibilities?.length > rowsPerPageResponsibilities &&
                                    <TablePagination
                                      rowsPerPageOptions={[5]}
                                      rowsPerPage={rowsPerPageResponsibilities}
                                      onRowsPerPageChange={handleResponsibilitiesChangeRowsPerPage}
                                      component="div"
                                      count={jobResponsibilities?.length}
                                      page={responsibilitiesPage}
                                      onPageChange={handleResponsibilitiesChangePage}
                                    />}
                                </TableContainer>
                              </div>
                            </div>
                            <div className="accordion-right">
                              <div style={{ display: "flex", flexDirection: "row", gap: "3px", alignItems: "center" }}>
                                <span className="sub-title">{t('qualifications')}</span>
                                <CircularButton
                                  currentTheme={currentTheme}
                                  aria-describedby={id}
                                  onClick={(e) => {
                                    try {
                                      setSysType("Job Qualifications");
                                      setSelectedSysCode(null);
                                      setAnchorEl(e.currentTarget);
                                      if (newCodeRef.current) {
                                        newCodeRef.current.focus();
                                      }

                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdAdd color="green" />} width={"30px"} height={"30px"} />
                              </div>
                              <div className="table-content">
                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                  <Table sx={{ width: "max-content", border: 'none' }}>
                                    <TableBody className="tablebody">
                                      {slicedQualificationsData?.map((row, index) => (
                                        <TableRow
                                          key={row?.qual_code_xx}
                                          className={`${selectedQualification?.qual_code_xx === row?.qual_code_xx ? "tablerow current" : "tablerow"}`}
                                          onClick={() => setSelectedResponsibility(row)}
                                        >
                                          <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                                            {qualificationsPage * rowsPerPage + index + 1}
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                                            <span className="sub-title">{row?.qual_code_xx}</span>
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            <span className="sub-title">{row?.qual_text_xx}</span>
                                          </TableCell>
                                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            <CircularButton
                                              currentTheme={currentTheme}
                                              onClick={async (e) => {
                                                try {
                                                  const res = await newRequest.post(`/hrJob/delQual/${selectedJob._id}`, { selected_code: row?.qual_code_xx });
                                                  if (res.data?.msg === "removed") {
                                                    setJobQualifications((prevData) => prevData.filter(doc => doc !== row));
                                                    showToast("Removed!", "success");
                                                  } else {
                                                    showToast("Error removing qualification!", "error");
                                                  }
                                                } catch (error) {
                                                  console.log(error);
                                                }
                                              }}
                                              color="#E53935" icon={<MdDelete />} width={"30px"} height={"30px"} />
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                  {jobQualifications.length > rowsPerPageQualifications &&
                                    <TablePagination
                                      rowsPerPageOptions={[5]}
                                      rowsPerPage={rowsPerPageQualifications}
                                      onRowsPerPageChange={handleQualificationsChangeRowsPerPage}
                                      component="div"
                                      count={jobQualifications.length}
                                      page={qualificationsPage}
                                      onPageChange={handleQualificationsChangePage}
                                    />}
                                </TableContainer>
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {filteredJobsData.length > rowsPerPage &&
              <TablePagination
                rowsPerPageOptions={[10]}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleJobChangeRowsPerPage}
                component="div"
                count={filteredJobsData.length}
                page={jobPage}
                onPageChange={handleJobChangePage}
              />}
          </TableContainer>
        </div>
      }
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={["hr-jobs"]}
                documentData={{
                  docNo: "1",
                  docType: "HR Jobs",
                  docId: "1"
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isJobDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title" style={{ textTransform: "uppercase" }}>{jobAction === "addJob" ? t('addJob') : t('editJob')}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    resetAction();
                    setIsJobDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                <div className="input-item-with-label">
                  <label htmlFor="job_code" style={{ width: "100px" }}>
                    {t('code').toUpperCase()}
                  </label>
                  <input
                    name="job_code"
                    type="text"
                    placeholder={t('code').toUpperCase()}
                    className="form-input-item"
                    style={{ width: "130px" }}
                    value={jobCode}
                    onChange={(e) => setJobCode(e.target.value)}
                    disabled={jobAction === "editJob"}
                  />
                </div>
                <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                  <Select
                    id="job_status"
                    name="job_status"
                    menuPortalTarget={document.body}
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="130px"
                    value={jobStatus}
                    onChange={(selectedOption) => setJobStatus(selectedOption)}
                    options={applicableJobStatuses}
                    isSearchable={true}
                    placeholder={t('status')}
                  />
                </div>
              </div>
              <div className="input-item-with-label">
                <label htmlFor="job_title" style={{ width: "100px" }}>
                  {t('title').toUpperCase()}
                </label>
                <input
                  name="job_title"
                  type="text"
                  placeholder={t('title').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={jobTitle}
                  onChange={(e) => setJobTitle(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label htmlFor="job_summary" style={{ width: "100px" }}>
                  {t('summary').toUpperCase()}
                </label>
                <input
                  name="job_summary"
                  type="text"
                  placeholder={t('summary').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={jobSummary}
                  onChange={(e) => setJobSummary(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label htmlFor="job_experience" style={{ width: "100px" }}>
                  {t('experience').toUpperCase()}
                </label>
                <input
                  name="job_experience"
                  type="text"
                  placeholder={t('experience').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={jobExperience}
                  onChange={(e) => setJobExperience(e.target.value)}
                />
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                iconPosition="end"
                currentTheme={currentTheme}
                borderRadiusType="right"
                onClick={handleJobAction}>
                {jobAction === "addJob" ? t('add').toUpperCase() : t('update').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      <Popover
        id={id}
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: "20px" }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "max-content",
            marginBottom: "5px"
          }}>
            <span className="main-title">{t('add').toUpperCase()}</span>
            <CircularButton currentTheme={currentTheme}
              onClick={() => {
                try {
                  setAnchorEl(null);
                  setSysType(null);
                  setSelectedSysCode(null);
                } catch (error) {
                  console.log(error);
                }
              }} icon={<MdClose />} width={"35px"} height={"35px"} />
          </div>
          <div className="input-item-with-label" style={{ gap: "3px" }}>
            <AsyncSelect
              ref={newCodeRef}
              id="selectedSysCode"
              name="selectedSysCode"
              menuPortalTarget={document.body}
              styles={{
                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                menuPortal: base => ({
                  ...base,
                  zIndex: 9999,
                })
              }}
              width="300px"
              value={selectedSysCode}
              onChange={(selectedOption) => setSelectedSysCode(selectedOption)}
              loadOptions={(inputValue, callback) => fetchSystemCodes(inputValue, callback, sysType)}
              isSearchable={true}
              placeholder={sysType === "Job Qualifications" ? t('qualifications').toUpperCase() : t('responsibilities').toUpperCase()}
              noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
            <CustomLoadingButton
              currentTheme={currentTheme}
              iconPosition="end"
              borderRadiusType="right"
              endIcon={<MdAdd />}
              onClick={async () => {
                try {
                  let addingType = "";
                  let url = "";
                  let title = "";

                  if (sysType === "Job Qualifications") {
                    addingType = t('selectQualification');
                    title = t('qualification');
                    url = `/hrJob/addQual/${selectedJob._id}`;
                  } else if (sysType === "Job Responsibilities") {
                    addingType = t('selectResponsibility');
                    title = t('responsibility');
                    url = `/hrJob/addResp/${selectedJob._id}`;
                  }

                  if (!selectedSysCode) {
                    setNotifyDialogTitle("Note!");
                    setNotifyDialogText(addingType);
                    setIsNotifyDialogOpen(true);
                    return;
                  }

                  const res = await newRequest.post(url, { selected_code: selectedSysCode?.value });

                  if (res.data?.msg === "exists") {
                    setSelectedSysCode(null);
                    showToast(t('qualRespExists', { param1: title, param2: selectedSysCode?.label }), "error");
                    if (newCodeRef.current) {
                      newCodeRef.current.focus();
                    }
                  } else if (res.data?.msg === "added") {
                    if (sysType === "Job Responsibilities") {
                      setJobResponsibilities((prevData) => {
                        const updated = [...prevData, res.data?.doc];
                        return updated.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
                      });
                    } else if (sysType === "Job Qualifications") {
                      setJobQualifications((prevData) => {
                        const updated = [...prevData, res.data?.doc];
                        return updated.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
                      });
                    }
                    showToast(`${selectedSysCode?.label} added!`, "success");
                    if (newCodeRef.current) {
                      newCodeRef.current.focus();
                    }
                    setSelectedSysCode(null);
                  } else {
                    showToast(res.data?.msg, "error");
                  }

                } catch (error) {
                  console.log(error);
                }
              }}>
              {t('add')}
            </CustomLoadingButton>
          </div>
        </div>
      </Popover>
    </motion.div>
  );
};

export default HrJob;
